module.exports = __webpack_public_path__ + "img/achievement_20.188340d9.png";